import * as React from 'react';
import _ from 'lodash';

import { OptionsItemizedReceiptSection } from 'components/business/receipts/OptionsItemizedReceiptSection';
import { Typography } from 'omakase';
import { core } from '@tock/coretypes';
import { mapOptionOrdersInternal } from '@tock/shared/utils/option';
import ReceiptLine from 'components/business/receipts/ReceiptLine';

interface Props {
  purchaseOrder: core.PurchaseOrder;
  patron: core.IPatron;
}

const SecondaryReceipt: React.FunctionComponent<Props> = ({ purchaseOrder, patron }) => {
  const ticketTypeName = purchaseOrder.ticketTypeName;
  const ticketTypePrice = purchaseOrder.ticketTypePrice;
  const partySize = purchaseOrder.ticketCount;

  const optionOrders = purchaseOrder.optionOrder.filter(
    (optionOrder) => optionOrder.patron?.id === patron.id
  );
  const options = mapOptionOrdersInternal(optionOrders, purchaseOrder.option);
  // todo if this gets more complicated, like secondary patron gift card application or discounts,
  // we'll probably want to move to a secondary patron scoped pricing support on the server side
  const optionsSubTotal = _.sum(_.map(options, (option) => option.amount * option.count));
  return (
    <div className="PastPurchaseSummary">
      <div className="Receipt-content Receipt-container--border ConsumerCheckout-section">
        <div className="Receipt-container--body">
          <div className="Receipt-content--title">
            <Typography component="h5" variant="body02Strong">
              Your Items
            </Typography>
          </div>
          <OptionsItemizedReceiptSection
            ticketTypeName={ticketTypeName}
            ticketTypePrice={ticketTypePrice}
            partySize={partySize}
            options={options}
          />
          {optionsSubTotal > 0 && (
            <>
              <div className="Receipt-separator" />
              <ReceiptLine amount={optionsSubTotal} lineItem={'Subtotal'} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SecondaryReceipt;
